import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';

/**
 * Service for domain related API calls.
 */
export default Service.extend({
  api: service(),
  store: service(),
  shData: service(),

  /**
   * Load the domain object for a specfic email address.
   *
   * @param {String} emailAddress
   * @return {Ember.RSVP.Promise}   Resolves with found domain.
   */
  loadDomainForEmail(emailAddress) {
    let emailParts = emailAddress.split('@');
    if (emailParts.length !== 2) {
      return Promise.reject(new Error('Invalid email format'));
    }

    let domain = emailParts[1],
      options = {
        params : {
          include: 'brands'
        }
      };

    return new Promise((resolve, reject) => {
      this.get('api').request(`/public/domains/${domain}`, options).then(response => {
        this.shData.pushResponseToStore(response);
        let domain = this.get('store').peekRecord('domain', response.data.id);
        resolve(domain);
      }).catch(e => {
        //We don't need to log this since it's likely this will fail while the user is typing an email.
        reject(e);
      });
    });
  }
});
